import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route's pathname changes.
 *
 * Mounts once inside <BrowserRouter>. Relies on `useLocation` so it triggers
 * for every kind of navigation: navbar links, mobile menu, footer links,
 * dashboard links, programmatic navigate() calls, and browser back/forward.
 *
 * Important non-goals (intentionally NOT touched):
 *  - Hash-anchor navigation (e.g. `/pricing#pricing` from Settings → Manage
 *    billing): if a hash is present we let the browser scroll to that anchor
 *    rather than forcing the top.
 *  - Same-page scroll helpers like Dashboard's scrollToLeadsSection() — those
 *    fire on clicks WITHOUT a pathname change, so this effect doesn't run.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser/hash-link handle anchor scrolling
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      // Older browsers reject `behavior: "instant"` — fall back to a plain jump.
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
